import { jsx } from 'react/jsx-runtime';
import Anchor from '../../../Anchor/index.js';
import '../../../../../StyleComponents/SCContainerStyledComponent.js';
import { SCDivStyledComponent } from '../../../../../StyleComponents/SCDivStyledComponents.js';
import '../../../../../StyleComponents/SCTextStyledComponent.js';
import { Margin } from '../../../../../StyleComponents/style.js';
import { RHSControlListItem } from '../EmpowerHeader/styles.js';
const HeaderAdditionalControlItem = _ref => {
  let {
    href,
    onClick,
    ariaLabel,
    children
  } = _ref;
  return /* @__PURE__ */jsx(RHSControlListItem, {
    children: /* @__PURE__ */jsx(SCDivStyledComponent, {
      css: Margin("x", 3),
      children: /* @__PURE__ */jsx(Anchor, {
        href: href || "#",
        onClick,
        ariaLabel,
        children
      })
    })
  });
};
export { HeaderAdditionalControlItem as default };